export const cities = {
    koto: {
        name: "江東区",
        statusLink: true,
        url: "https://yoyaku.koto-sports.net/",
        lots: "2ヶ月前の20日〜月末(屋外施設)、4ヶ月前の20日〜月末(屋内施設)",
        reservation:
            "1ヶ月前の9日の午前9時(野球・ソフトボール・サッカー)、1ヶ月前の9日の正午(テニス)、3ヶ月前の9日の午前10時(屋内施設)"
    },
    nerima: {
        name: "練馬区",
        statusLink: true,
        url: "https://yoyaku.city.nerima.tokyo.jp/stagia/reserve/gin_menu",
        lots:
            "テニス：１回目抽選1日～9日 ２回目抽選16日～22日、テニス以外：1日～9日"
    },
    tokyo: {
        name: "東京都",
        statusLink: true,
        url: "https://yoyaku.sports.metro.tokyo.lg.jp/",
        lots: "利用日前月の１日〜１０日",
        reservation: "利用日前月の22日"
    },
    kanagawa: {
        name: "神奈川県",
        statusLink: false,
        url: "https://yoyaku.e-kanagawa.lg.jp/Portal/Web/",
        lots:
            "利用日の前月の1日～10日、利用日の２か月前の1日～10日(県立スポーツセンター、四之宮ふれあい広場(地元専用))",
        reservation:
            "利用日の前月の16日、利用日の２か月前の16日(県立スポーツセンター、四之宮ふれあい広場(地元専用))"
    },
    ota: {
        name: "大田区",
        statusLink: true,
        url: "https://www.yoyaku.city.ota.tokyo.jp/",
        lots: "利用日2か月前の15日～末日",
        reservation: "利用日前月の8日"
    },
    edogawa: {
        name: "江戸川区",
        statusLink: true,
        url: "https://www.edogawa-yoyaku.jp/",
        lots: "利用日の前月1日〜10日(テニス、野球、サッカー)、利用日の3ヶ月前の1日〜10日(屋内施設)",
        reservation: "利用日の前月12日12時(区内)、13日(区外)、14日(小中学生)、利用日の3ヶ月前の20日12時(屋内施設)"
    }
};